import React from "react";
import { RouteObject } from "react-router-dom";
import { SUPPORTED_LANGUAGES } from "../../../utils/languageRouting";
import ClientProfileSettings from "../components/ClientProfileSettings";
import PostJobPage from "../components/PostaJob";
import ClientLayout from "../ClientLayout";
import ClientProfile from "../components/ClientProfile1";
import ClientDashboard from "../../../pages/Main/client";
import ClientFavorites from "../../../pages/ClientFavorites";
import LawyerRequestForm from "../../../pages/Main/LawyerRequestForm";

const baseClientRoutes: RouteObject[] = [
    {
        path: "/clients",
        element: <ClientLayout />,
        children: [
            { path: "", element: <ClientDashboard /> },
            { path: "profilesettings", element: <ClientProfileSettings /> },
            { path: "postajob", element: <PostJobPage /> },
            { path: "postajob/international", element: <PostJobPage jobType={"international"} /> },
            { path: "postajob/:jobId", element: <PostJobPage /> },
            { path: "postajob/international/:jobId", element: <PostJobPage jobType={"international"} /> },
            { path: "profile", element: <ClientProfile /> },
            { path: "profile/:userId", element: <ClientProfile /> },
            { path: "favorites", element: <ClientFavorites /> },
            { path: "lawyerRequestForm", element: <LawyerRequestForm /> },
        ],
    },
];

/**
 * Create language-prefixed client routes
 */
const createLanguagePrefixedClientRoutes = (): RouteObject[] => {
    const languagePrefixedRoutes: RouteObject[] = [];
    
    SUPPORTED_LANGUAGES.filter(lang => lang !== "en").forEach(lang => {
        baseClientRoutes.forEach(route => {
            // Add language prefix: /it/clients
            languagePrefixedRoutes.push({
                ...route,
                path: `/${lang}${route.path}`,
            });
            
            // Also add language suffix: /clients/it
            languagePrefixedRoutes.push({
                ...route,
                path: `${route.path}/${lang}`,
            });
        });
    });
    
    return languagePrefixedRoutes;
};

const ClientRoutes: RouteObject[] = [
    ...baseClientRoutes,
    ...createLanguagePrefixedClientRoutes(),
];

export default ClientRoutes;